import axios from "axios"
import HttpClientService from "./httpClient.service"

class AuthService extends HttpClientService {
  constructor() {
    super({})
  }
  login(payload) {
    const url = payload.invitation ? `api/login?invitation_id=${payload.invitation}` : "api/login"
    return this.post(url, { payload }).catch((error) => {
      throw error
    })
  }

  loginWithGoogle(payload) {
    return this.post(`api/social-login`, { payload }).catch((error) => {
      throw error
    })
  }

  signUp(payload) {
    return this.post("api/users/signup", { payload })
  }

  signUpWithGoogle(payload) {
    return this.post(`api/users/social-signup`, { payload }).catch((error) => {
      throw error
    })
  }

  updateToken(refreshToken) {
    const payload = { refresh_token: refreshToken }
    return this.post(`api/token/refresh`, { payload }).catch((error) => {
      throw error
    })
  }

  singleSignOn(accountId, email) {
    return this.post(`api/saml/login/${accountId}`, {
      payload: {
        email
      }
    }).catch((error) => {
      throw error
    })
  }
}

const authService = new AuthService()

export default authService
